import { Component, input, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import type { TemplateRef } from '@angular/core';
import { TemplateField } from '../../../models/template.model';
import { UpperCasePipe } from '@angular/common';
import { L10nTranslatePipe } from 'angular-l10n';


@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'compare-record-header',
  templateUrl: './compare-record-header.component.html',
  styleUrl: './compare-record-header.component.scss',
  imports: [UpperCasePipe, L10nTranslatePipe],
})
export class CompareRecordHeaderComponent implements OnInit, OnDestroy {
  readonly allFields = input<TemplateField[]>();
  readonly showGroup = input<boolean>();
  readonly confidentialityTmpl = input<TemplateRef<any>>();
  constructor() {}

  ngOnInit() {
    /* required for static lable translation */
  }

  ngOnDestroy() {
    /* label translation purpose added */
  }
}
